import { hexToRgb } from '@kutil';
import { Deserializable } from './deserializable.model';

export class Theme implements Deserializable<any, Theme> {
  constructor(
    public backgroundImageUrl?: string,
    public primary?: string,
    public secondary?: string,
    public surface?: string,
    public onBackground?: string,
    public gradientColor1?: string,
    public gradientColor2?: string,
    public gradientColor3?: string,
    public iconUrl?: string,
    public iconUrlWithTag?: string,
    public onBackgroundIconUrl?: string,
    public onBackgroundIconUrlWithTag?: string,
    public backgroundImageUrlMobile?: string
  ) {
    if (backgroundImageUrl && !backgroundImageUrlMobile) {
      this.backgroundImageUrlMobile = backgroundImageUrl;
    }
  }

  deserialize(input: any): Theme {
    if (input == null) {
      return null;
    }

    this.backgroundImageUrl = input['backgroundImageUrl'];
    this.backgroundImageUrlMobile = input['backgroundImageUrlMobile'] || input['backgroundImageUrl'];
    this.primary = input['primaryColor'] || input['primary'];
    this.secondary = input['secondaryColor'] || input['secondary'];
    // default surfaceColor to primaryColor from API if it doesn't exist
    this.surface = input['surfaceColor'] || input['primaryColor'] || input['primary'];
    this.onBackground = input['onBackgroundColor'] || input['onBackground'];
    this.gradientColor1 = input['gradientColor1'];
    this.gradientColor2 = input['gradientColor2'];
    this.gradientColor3 = input['gradientColor3'];
    this.iconUrl = input['iconUrl'];
    this.iconUrlWithTag = input['iconUrlWithTag'];
    this.onBackgroundIconUrl = input['onBackgroundIconUrl'];
    this.onBackgroundIconUrlWithTag = input['onBackgroundIconUrlWithTag'];

    return this;
  }

  getColorWithTransparency(property, opacity) {
    return this[property]
      ? `rgba(${hexToRgb(this[property]).r}, ${hexToRgb(this[property]).g}, ${hexToRgb(this[property]).b}, ${opacity})`
      : this[property];
  }
}
